module.exports = __webpack_public_path__ + "452baf6d161550fd6a59399dcf85d924.pdf";